<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_ix">ACKNOWLEDGMENTS</a></p><a id="page_ix">
<p class="noindent">For permission to draw on previously published material, I am grateful to the editors/publishers of the following journals: <i>Internationales Jahrbuch für Hermeneutik, Southern Journal of Philosophy</i>, and <i>Journal of Speculative Philosophy</i>. Thanks also to the editor and publisher of <i>Phenomenological Perspectives on Plurality</i>.</p>
<p class="indent">All translations are my own.</p>
<p class="indentb">I am grateful to Nancy Fedrow, Ryan Brown, and Stephen Mendelsohn for their fine assistance during production of this book. The support that my editor and friend Dee Mortensen has provided for the present project has been indispensable, and I am especially grateful to her.</p>
<p class="indent"><i>Boston</i></p>
<p class="indent"><i>May 2016</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Acknowledgement.vue?16c1e33e